import { useMemo } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { useFilteredCategoryList } from '@zet/feature-brands/api/brands/hooks'

export interface IInEligibleBrandsListParams {
  customerId: string
  categoryId: string
}
const useInEligibleData = (params: IInEligibleBrandsListParams) => {
  const queryClient = useQueryClient()

  const inEligiblePartners = useMemo(
    () =>
      queryClient.getQueryData([
        'recommendationIneligible',
        params?.categoryId,
        params?.customerId,
      ]),
    [queryClient, params]
  )

  const { data } = useFilteredCategoryList({
    customerId: params?.customerId,
    categoryId: params?.categoryId,
    type: 'inEligiblePartners',
    isInEligiblePartners: typeof inEligiblePartners === 'undefined',
  })

  const inEligibleList = inEligiblePartners || data?.inEligiblePartners
  return { inEligibleList }
}

export default useInEligibleData
